import type { ReactNode } from "react";
import { Grid, Paper, Skeleton, Stack, Typography } from "@mui/material";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import { grey } from "@mui/material/colors";
import { useInformationsRuc } from "hooks";

interface InformationRucGridFragmentProps {
  libelle: string;
  value?: string;
}
function InformationRucGridFragment({
  libelle,
  value,
}: Readonly<InformationRucGridFragmentProps>): ReactNode {
  const valueOrDefault = value == null || value === "" ? "N/A" : value;

  return (
    <Grid size={{ xs: 12, md: 6, lg: 3 }}>
      <Typography>
        {libelle}&nbsp;:{" "}
        <Typography component="span" sx={{ color: "info.main", fontWeight: 500 }}>
          {valueOrDefault}
        </Typography>
      </Typography>
    </Grid>
  );
}

interface InformationsRucBoxProps {
  communeId?: string;
}
function InformationsRucBox({ communeId }: Readonly<InformationsRucBoxProps>): ReactNode {
  const { isLoading, informationRuc: infosRuc } = useInformationsRuc({ communeId });

  if (infosRuc == null || infosRuc.communeCodeInsee !== communeId) {
    return undefined;
  }

  return (
    <Grid
      container
      size={12}
      spacing={1}
      component={Paper}
      variant="outlined"
      sx={{
        alignContent: "flex-start",
        borderColor: grey[400],
        borderWidth: 2,
        p: 2,
      }}>
      <Grid size={12}>
        <Stack direction="row" spacing={1} alignItems="center">
          <ContactPhoneIcon sx={{ color: grey[500] }} />
          <Typography variant="subtitle2">Relation usagers clients</Typography>
        </Stack>
      </Grid>
      {isLoading ? (
        <Skeleton sx={{ height: "73px", width: "100%", marginY: "-15px" }} />
      ) : (
        <Grid container size={12}>
          <InformationRucGridFragment libelle="Relève compteur" value={infosRuc.releveCompteur} />
          <InformationRucGridFragment libelle="Trésorerie" value={infosRuc.tresorerie} />
          <InformationRucGridFragment libelle="Période mensuelle" value={infosRuc.periodeMensu} />
          <InformationRucGridFragment
            libelle="Prélèvement solde mensuel"
            value={infosRuc.prelevementSoldeMensu}
          />
          <InformationRucGridFragment
            libelle="Identifiant structure publique facture eau"
            value={infosRuc.identifiantStructurePubliqueFactureEau}
          />
          <InformationRucGridFragment
            libelle="Code produit ROLEREC"
            value={infosRuc.rolerecCodeProduit}
          />
          <InformationRucGridFragment
            libelle="Identifiant structure publique facture ASST"
            value={infosRuc.identifiantStructurePubliqueFactureAsst}
          />
          <InformationRucGridFragment
            libelle="Code produit ROLEREC ASST"
            value={infosRuc.rolerecCodeProduitAsst}
          />
        </Grid>
      )}
    </Grid>
  );
}

export default InformationsRucBox;
